import angular from "angular";
import Vue from "vue";
import "ngVue";

import RoadmapEditor from "./RoadmapEditor.vue";

export default angular
  .module("directives.roadmapeditor", [])
  .directive("dcRoadmapEditor", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcRoadmapEditor", RoadmapEditor));
    },
  ]);
